import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert, Button, TextFieldWithLabel, Typography } from 'shared/ui'
import { PresetContainer, PresetField, PresetFooter } from 'shared/Preset'

type IDeleteClientModalProps = {
  name: string
  onClose: () => void
  onDelete: () => Promise<void>
}

export const DeleteClientModal = observer(
  ({ name, onClose, onDelete }: IDeleteClientModalProps) => {
    const [deleteName, setDeleteName] = useState('')
    const [loading, setLoading] = useState(false)
    const [isNameValid, setIsNameValid] = useState(true)

    const handleSave = async () => {
      validateName()
      if (!isNameValid) return

      setLoading(true)
      await onDelete()
      setLoading(false)
    }

    const validateName = () => {
      setIsNameValid(deleteName.toLowerCase() === `remove ${name.toLowerCase()}`)
    }

    return (
      <PresetContainer>
        <Alert
          item={{
            type: 'alert',
            desc: 'Your agency will permanently lose access to this client account. This action cannot be undone.',
          }}
          marginInline={24}
          marginBottom={8}
        />
        <PresetField>
          <TextFieldWithLabel
            labelProps={{
              label: {
                text: (
                  <Typography
                    variant='text-input-label-small'
                    ariaLabel='RemoveClientLabel'
                    color='var(--content-primary-tertiary)'
                  >
                    {'Type '}
                    <span style={{ color: 'var(--content-primary-primary)' }}>“Remove {name}”</span>
                    {' to confirm'}
                  </Typography>
                ),
              },
            }}
            errorMessage={!isNameValid ? `Must match the following: “Remove ${name}”` : ''}
            textFieldProps={{
              InputProps: {
                placeholder: `Remove ${name}`,
              },
              value: deleteName,
              onChange: setDeleteName,
              onBlur: validateName,
              error: !isNameValid,
            }}
          />
        </PresetField>
        <PresetFooter>
          <Button text='Cancel' size='medium' contained='secondary' onClick={onClose} />
          <Button
            text='Remove'
            size='medium'
            intent='destructive'
            disabled={!deleteName.length || !isNameValid || loading}
            onClick={handleSave}
          />
        </PresetFooter>
      </PresetContainer>
    )
  }
)
